// ShareLink is one of the member's links that show their location to someone
// without an account (spec 001 FR-086).
export interface ShareLink {
  id: string;
  created_at: string;
  ends_at: string;
  place_name?: string;
}

// activeAt returns the links whose time has not passed at now, in
// milliseconds. The server sends nothing when a link's time passes, so the
// map drops it itself (001 FR-114).
export function activeAt(links: ShareLink[], now: number): ShareLink[] {
  return links.filter((l) => new Date(l.ends_at).getTime() > now);
}

// nextEnd is when the soonest of the links ends, in milliseconds, or null
// with none.
export function nextEnd(links: ShareLink[]): number | null {
  if (links.length === 0) return null;
  return Math.min(...links.map((l) => new Date(l.ends_at).getTime()));
}
